import moment from 'moment';
import React from 'react';
import { Alert } from 'reactstrap';
import { MomentDateFormat } from '../MomentDateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

export default class AdjustmentDetail extends React.Component {
    render() {
        const { entity, modifyingUsers, isAdmin } = this.props;

        if (
            !isAdmin ||
            !entity ||
            !entity.modifiedOn ||
            !entity.modifiedBy ||
            !modifyingUsers
        ) {
            return null;
        }

        const employee = modifyingUsers.find(
            (mu) => mu.modifiedBy == entity.modifiedBy
        );

        const displayName = employee ? employee.displayName : entity.modifiedBy;

        return (
            <Alert color="success" fade={false}>
                <FontAwesomeIcon icon={faFileAlt} className="mr-2" />
                Last modified by {displayName} on{' '}
                {moment
                    .utc(entity.modifiedOn)
                    .local()
                    .format(MomentDateFormat.DateTimeShortAnte)}
                .
            </Alert>
        );
    }
}
